module.exports = __webpack_public_path__ + "img/9791158880309.d639adf1.jpg";